import Products from './Products';

export default Products;


// WEBPACK FOOTER //
// ./src/components/Query/Products/index.tsx